<rid-syllabic-keyboard [layout]="layout()" [mode]="mode()" [mask]="finalMask()" [disabled]="waiting()" (typed)="press($event)" />
